import PropTypes from 'prop-types'

export const API_IMAGE_OBJECT = PropTypes.shape({
  _renditions: PropTypes.objectOf(
    (propValue, key) => {
      if (!/^\d+x\d+$/.test(key)) {
        return new Error('Key must be of format "[width]x[height]"')
      }
      return true
    }
  ),
})

export const API_PROGRAMME_OBJECT = PropTypes.shape({
  guid: PropTypes.string,
  name: PropTypes.string,
  shortName: PropTypes.string,
  shortDescription: PropTypes.string,
  availableEpisodes: PropTypes.number,
})

export const API_VIDEO_OBJECT = PropTypes.shape({
  id: PropTypes.number,
  guid: PropTypes.string,
  slug: PropTypes.string,
  tags: PropTypes.string,
  length: PropTypes.number,
  _duration: PropTypes.string,
})

export const VOD_VIDEO_PARAMS_OBJECT = PropTypes.shape({
  duration: PropTypes.number,
  chapter: PropTypes.string,
  contentIsChapter: PropTypes.bool,
  id: PropTypes.string,
  type: PropTypes.string,
  playerApiRefId: PropTypes.string,
  groupToken: PropTypes.string,
  isPlayerPlus: PropTypes.bool,
  drmEnabled: PropTypes.bool,
})

export const EPISODE_INFO_OBJECT = PropTypes.shape({
  episodeId: PropTypes.number,
  episodeGuid: PropTypes.string,
  programmeGuid: PropTypes.string,
  name: PropTypes.string,
  title: PropTypes.string,
  summary: PropTypes.string,
  startTime: PropTypes.string,
  duration: PropTypes.string,
  availableUntil: PropTypes.string,
  hasSubtitles: PropTypes.bool,
  hasMoreEpisodes: PropTypes.bool,
})

export const CARD_OBJECT = PropTypes.shape({
  link: PropTypes.string,
  label: PropTypes.string,
  summary: PropTypes.string,
  title: PropTypes.string,
  availableUntil: PropTypes.string,
  image: API_IMAGE_OBJECT,
  duration: PropTypes.string,
  hasSubtitles: PropTypes.bool,
  hasGuidanceText: PropTypes.bool,
  hasInfoText: PropTypes.bool,
  programmeName: PropTypes.string,
  genre: PropTypes.string,
  durationOverlay: PropTypes.bool,
  progress: PropTypes.number,
  forceAds: PropTypes.bool,
})

export const PROMOTED_GROUP_ASSET_OBJECT = PropTypes.shape({
  type: PropTypes.string,
  assetGuid: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  label: PropTypes.string,
  programme: API_PROGRAMME_OBJECT,
  overlay: PropTypes.string,
  image: API_IMAGE_OBJECT,
  endDate: PropTypes.string,
  isLive: PropTypes.bool,
  newWindow: PropTypes.bool,
  startDate: PropTypes.string,
  _permalink: PropTypes.string,
  _extraInformation: PropTypes.shape({
    now: PropTypes.shape({
      title: PropTypes.string,
      startTime: PropTypes.string,
      endTime: PropTypes.string,
    }),
    next: PropTypes.shape({
      title: PropTypes.string,
      startTime: PropTypes.string,
      endTime: PropTypes.string,
    }),
  }),
})

export const PROMOTED_GROUP_OBJECT = PropTypes.shape({
  id: PropTypes.number,
  type: PropTypes.string,
  active: PropTypes.bool,
  slug: PropTypes.string,
  name: PropTypes.string,
  subTitle: PropTypes.string,
  buttonUrl: PropTypes.string,
  buttonText: PropTypes.string,
  assets: PropTypes.arrayOf(PROMOTED_GROUP_ASSET_OBJECT),
})

export const SHORTFORM_COLLECTION_OBJECT = PropTypes.shape({
  guid: PropTypes.string,
  isFeatured: false,
  name: PropTypes.string,
  programme: PropTypes.shape({
    guid: PropTypes.string,
    name: PropTypes.string,
    shortDescription: PropTypes.string,
    shortName: PropTypes.string,
  }),
})

export const SHORTFORM_OBJECT = PropTypes.shape({
  guid: PropTypes.string,
  name: PropTypes.string,
})

export const TAB_OBJECT = PropTypes.shape({
  id: PropTypes.string,
  title: PropTypes.string,
  section: PropTypes.string,
  params: PropTypes.shape({
    path: PropTypes.string,
  }),
})

export const COLLECTION_OBJECT = PropTypes.shape({
  guid: PropTypes.string,
  isFeatured: PropTypes.bool,
  name: PropTypes.string,
  programme: PropTypes.shape(
    {
      guid: PropTypes.string,
      name: PropTypes.string,
      shortDescription: PropTypes.string,
      shortName: PropTypes.string,
    }
  ),
})

export const SEARCH_RESULT = PropTypes.shape({
  title: PropTypes.shape({
    raw: PropTypes.string,
  }),
  category: PropTypes.shape({
    raw: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  }),
  body: PropTypes.shape({
    raw: PropTypes.string,
  }),
  url: PropTypes.shape({
    raw: PropTypes.string,
  }),
})

export const ERROR_OBJECT = PropTypes.shape({
  message: PropTypes.string,
  code: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  currentUrl: PropTypes.string,
  httpStatus: PropTypes.number,
})
